import React, { useState, useRef, useEffect } from 'react';
import { MessageCircle, X, ChevronRight } from 'lucide-react';
import './WhatsAppWidget.css';

export function WhatsAppWidget() {
    const [isOpen, setIsOpen] = useState(false);
    const widgetRef = useRef(null);

    // Kept only the two requested numbers
    const whatsappNumbers = ['01028989353', '01273148393'];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (widgetRef.current && !widgetRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleChat = (num) => {
        window.open(`https://wa.me/2${num}`, '_blank');
        setIsOpen(false);
    };

    return (
        <div className="wa-luxury-widget" ref={widgetRef}>
            <div className={`wa-luxury-menu ${isOpen ? 'open' : ''}`}>
                <div className="wa-luxury-header">
                    <span>WhatsApp Support</span>
                    <p>تواصل معنا عبر الواتساب</p>
                </div>
                <div className="wa-luxury-body">
                    {whatsappNumbers.map((num, i) => (
                        <button key={i} className="wa-luxury-row" onClick={() => handleChat(num)}>
                            <div className="wa-icon-circle">
                                <MessageCircle size={14} />
                            </div>
                            <span className="wa-number">{num}</span>
                            <ChevronRight size={14} className="wa-arrow" />
                        </button>
                    ))}
                </div>
            </div>

            <button 
                className={`wa-luxury-trigger ${isOpen ? 'active' : ''}`} 
                onClick={() => setIsOpen(!isOpen)}
                aria-label="WhatsApp Chat"
            >
                {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
                {!isOpen && <span className="wa-gold-pulse"></span>}
            </button>
        </div>
    );
}
